import { createSignal, createResource, onMount, createContext, useContext, Suspense, Show } from "solid-js";
import * as i18n from "@solid-primitives/i18n";

export const LOCALES = ["en", "sv"]; // extend as needed

export async function fetchDictionary(locale) {
  // Avoid dynamic import of the same directory to satisfy Vite restrictions
  const loaders = {
    en: () => import('./en.json'),
    sv: () => import('./sv.json'),
  };
  const load = loaders[locale] ?? loaders.en;
  const mod = await load();
  const dict = mod.default;
  return i18n.flatten(dict);
}

const I18nCtx = createContext();

export function I18nProvider(props) {
  const [locale, setLocale] = createSignal("sv");

  onMount(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem("locale");
      if (saved) setLocale(saved);
    }
  });

  const [dict] = createResource(locale, fetchDictionary);

  const t = i18n.translator(dict);

  const switchLocale = (l) => {
    setLocale(l);
    localStorage.setItem("locale", l);
  };

  return (
    <I18nCtx.Provider value={{ t, dict, locale, setLocale: switchLocale }}>
      <Suspense fallback={props.fallback ?? null}>
        <Show when={dict()}>{props.children}</Show>
      </Suspense>
    </I18nCtx.Provider>
  );
}

export function useI18n() { 
  const ctx = useContext(I18nCtx);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
